module.exports = __webpack_public_path__ + "img/bt.6035685f.png";